// Common feature flags used in the application
export const FEATURE_FLAGS = {
  GROUP_CHAT: 'cfg__group_chat',
  SCHEDULE_UPLOAD: 'cfg__schedule_upload',
  DEPARTMENTS: 'cfg__departments',
  SKILLS: 'cfg__skill',
  ACTION_MENU: 'cfg__action_menu',
  INVITE_TEAM: 'cfg__invite_team',
  POST_OPEN_SHIFT: 'cfg__shift__post_open_shift',
  VTO: 'cfg_vto',
};

// Helper function to create a tour step with feature requirement
export const createFeatureStep = (target, content, placement = 'bottom', requiresFeature = null) => ({
  target,
  content,
  placement,
  disableBeacon: true,
  ...(requiresFeature && { requiresFeature }),
});

// Route-specific tour configurations
export const routeTours = {
//   // Schedule Calendar (main dashboard)
//   '/': {
//     key: 'scheduleCalendar',
//     title: 'Welcome to Schedule Calendar',
//     steps: [
//       {
//         target: '.schedule-calendar__wrap',
//         content: 'This is your main schedule view. Here you can see all shifts, manage your team, and coordinate schedules.',
//         placement: 'bottom',
//         disableBeacon: true,
//       },
//       {
//         target: '.schedule-header-component',
//         content: 'Use the header to navigate between dates, publish schedules, and access quick actions.',
//         placement: 'bottom',
//         disableBeacon: true,
//       },
//       {
//         target: '.calendar-table__wrap',
//         content: 'The schedule table shows all shifts. Click on any cell to add or edit shifts.',
//         placement: 'top',
//         disableBeacon: true,
//       }
//     ]
//   },
//   '/schedulecalendar': {
//     key: 'scheduleCalendar',
//     title: 'Schedule Calendar',
//     steps: [
//       {
//         target: '.schedule-calendar__wrap',
//         content: 'This is your main schedule view. Here you can see all shifts, manage your team, and coordinate schedules.',
//         placement: 'bottom',
//         disableBeacon: true,
//       },
//       {
//         target: '.schedule-header-component',
//         content: 'Use the header to navigate between dates, publish schedules, and access quick actions.',
//         placement: 'bottom',
//         disableBeacon: true,
//       },
//       {
//         target: '.calendar-table__wrap',
//         content: 'The schedule table shows all shifts. Click on any cell to add or edit shifts.',
//         placement: 'top',
//         disableBeacon: true,
//       }
//     ]
//   },

  // User Management
  '/usermanagement': {
    key: 'userManagement',
    title: 'User Management',
    steps: [
      createFeatureStep(
        '.management__wrap',
        'Manage your team members here. Add new employees, edit profiles, and control access.'
      ),
      createFeatureStep(
        '.employee-page-header__add-users',
        'Click here to add new team members to your organization.'
      ),
      createFeatureStep(
        '.table',
        'View and manage all your team members. Click on any user to edit their details.',
        'top'
      ),
      createFeatureStep(
        '.category__wrap',
        'Organize your team by departments, groups, and skills based on your location settings.',
        'bottom',
        FEATURE_FLAGS.DEPARTMENTS
      )
    ]
  },

  // Requests
  '/requests': {
    key: 'requests',
    title: 'Requests Management',
    steps: [
      {
        target: 'main',
        content: 'Handle time-off requests, shift swaps, and other employee requests here.',
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: '.main-content',
        content: 'Filter requests by status, type, or date range to find what you need quickly.',
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: 'body',
        content: 'Review and approve or deny requests. Click on any request for detailed information.',
        placement: 'top',
        disableBeacon: true,
      }
    ]
  },

  // Community/Team Feed
  '/team-feed': {
    key: 'teamFeed',
    title: 'Team Community',
    steps: [
      createFeatureStep(
        'main',
        'Stay connected with your team through posts, announcements, and discussions.',
        'bottom',
        FEATURE_FLAGS.GROUP_CHAT
      ),
      createFeatureStep(
        '.main-content',
        'Share updates, announcements, or start discussions with your team.',
        'bottom',
        FEATURE_FLAGS.GROUP_CHAT
      ),
      createFeatureStep(
        'body',
        'View and interact with team posts. Like, comment, and stay updated.',
        'top',
        FEATURE_FLAGS.GROUP_CHAT
      )
    ]
  },

  // Scheduler
  '/scheduler': {
    key: 'scheduler',
    title: 'Schedule Upload',
    steps: [
      createFeatureStep(
        'main',
        'Upload existing schedules from Excel or CSV files to quickly populate your calendar.',
        'bottom',
        FEATURE_FLAGS.SCHEDULE_UPLOAD
      ),
      createFeatureStep(
        '.main-content',
        'Drag and drop your schedule files here or click to browse.',
        'bottom',
        FEATURE_FLAGS.SCHEDULE_UPLOAD
      ),
      createFeatureStep(
        'body',
        'Download our template to ensure your file format is compatible.',
        'top',
        FEATURE_FLAGS.SCHEDULE_UPLOAD
      )
    ]
  },

  // Settings
  '/settings': {
    key: 'settings',
    title: 'Settings & Configuration',
    steps: [
      {
        target: 'main',
        content: 'Configure your organization settings, manage subscriptions, and customize your experience.',
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: '.main-content',
        content: 'Navigate between different settings categories using the sidebar.',
        placement: 'right',
        disableBeacon: true,
      },
      {
        target: 'body',
        content: 'View and modify settings for the selected category.',
        placement: 'left',
        disableBeacon: true,
      }
    ]
  },

  // Team Profile
  '/team': {
    key: 'teamProfile',
    title: 'Team Profile',
    steps: [
      {
        target: 'main',
        content: 'View detailed information about team members and their schedules.',
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: '.main-content',
        content: 'See employee details, contact information, and current status.',
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: 'body',
        content: 'View individual schedules and manage shifts for this team member.',
        placement: 'top',
        disableBeacon: true,
      }
    ]
  }
};

// Helper function to get tour for a specific route
export const getRouteTour = (pathname) => {
  // // Handle dynamic routes with parameters
  // const basePath = pathname.split('/').slice(0, 2).join('/');
  
  // // Check exact matches first
  // if (routeTours[pathname]) {
  //   return routeTours[pathname];
  // }
  
  // // Check base path matches for dynamic routes
  // if (routeTours[basePath]) {
  //   return routeTours[basePath];
  // }
  
  // // Check if it's a settings route
  // if (pathname.startsWith('/settings/')) {
  //   return routeTours['/settings'];
  // }
  
  // // Check if it's a requests route
  // if (pathname.startsWith('/requests/')) {
  //   return routeTours['/requests'];
  // }
  
  // // Check if it's a team-feed route
  // if (pathname.startsWith('/team-feed/')) {
  //   return routeTours['/team-feed'];
  // }
  
  // // Check if it's a team profile route
  // if (pathname.startsWith('/team/')) {
  //   return routeTours['/team'];
  // }
  
  return null;
};

// Helper function to get session storage key for a tour
export const getTourSessionKey = (tourKey) => {
  return `hasSeen${tourKey.charAt(0).toUpperCase() + tourKey.slice(1)}Tour`;
}; 